import { fetchAPI } from "./baseApi";

export async function getAnnouncements() {
  return fetchAPI("/announcement/list", {
    method: "GET",
  });
}

export async function createAnnouncement(data) {
  return fetchAPI("/announcement", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function updateAnnouncement(id, data) {
  return fetchAPI(`/announcement/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
}

export async function deleteAnnouncement(id) {
  return fetchAPI(`/announcement/${id}`, {
    method: "DELETE",
  });
}
